import { axiosInstance } from '../axiosInstance';
import { returnErrors, clearErrors } from '../actions/errorActions';
import { 
    RESET_PASSWORD_LOADING,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL
} from "./types";

export const resetPassword = ({ password, password_confirmation, verification_code }) => {
    return async function(dispatch){
        //Headers

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        dispatch(clearErrors());
        dispatch({
            type: RESET_PASSWORD_LOADING
        });
        const body = { password, password_confirmation, verification_code };
        try {
            let response = await axiosInstance.post(
                '/api/change_password', 
                body,
                config
            );
            if(response.status !== 200){
                dispatch({
                    type: RESET_PASSWORD_FAIL,
                });
                throw Error({
                    response: {
                        data: "Other Errors",
                        status: "Other Errors"
                    },
                })
            }else{
                dispatch({
                    type: RESET_PASSWORD_SUCCESS,
                    payload: response.data
                })
            }
        } catch (error) {
            if(error.response && error.response.data){
                dispatch(returnErrors(error.response.data, error.response.status, 'RESET_PASSWORD_FAIL'));
                dispatch ({ 
                    type: RESET_PASSWORD_FAIL 
                });
            }else{
                let errorJson = JSON.stringify(error);
                let errorParsed = JSON.parse(errorJson);
                return (
                    dispatch(returnErrors(errorParsed.message, "Network Error", 'RESET_PASSWORD_FAIL')),
                    dispatch ({ 
                        type: RESET_PASSWORD_FAIL 
                    })
                )
            }
        }
    }
};